// logoutHelper.js
import store from '../store/reducers/store'; // adjust the path to your Redux store
import { clearUploadedDocument, toggleFullView } from "../store/reducers/uploadDocumentSlice";
import { logout } from '../store/reducers/authReducer';
import Cookies from "js-cookie";

const logoutChannel = new BroadcastChannel("logout_channel");

export const logoutUser = () => {
  // Dispatch actions
  store.dispatch(clearUploadedDocument());
  store.dispatch(toggleFullView());
  store.dispatch(logout());

  // Clear local/session storage
  localStorage.clear();
  sessionStorage.clear();

  // Clear cookies
  document.cookie.split(";").forEach(cookie => {
    const name = cookie.split("=")[0].trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });

  // Notify other tabs and redirect
  logoutChannel.postMessage("logout");
  window.location.replace(`${process.env.PUBLIC_URL}/new/admin-login`);
};
